import {Link} from 'react-router-dom'
import {useContext, useEffect, useState} from 'react'
import MUIDataTable from 'mui-datatables'
import api from '../../../services/api'
import {DataTableOptions} from '../../../components/dataTableOptions'
import {MainContext} from '../../../context/MainContext'
import IEventCategories from '../../../interfaces/IEventCategories'

export default function ListingEventCategories({eventTypeId}: any) {
  const {setLoading} = useContext(MainContext)
  const [categories, setCategories] = useState<IEventCategories[]>([])

  const getCategories = async () => {
    try {
      const response = await api.get<IEventCategories[]>(`/api/event-categories?event_type_id=${eventTypeId}&show_inactive=true`)
      setCategories(response.data)
    } catch (error) {
      console.error('Error fetching event categories:', error)
    }
  }

  useEffect(() => {
    setLoading(true)
    getCategories().then(() => setLoading(false))
  }, [])

  const columns: any = [
    {name: 'category_name', label: 'Categoria', options: {filter: false, sort: true}},
    {name: 'genre', label: 'Gênero', options: {filter: false, sort: true}},
    {name: 'grade', label: 'Classe', options: {filter: false, sort: true}},
    {
      name: 'active',
      label: 'Status',
      options: {
        filter: false,
        sort: false,
        customBodyRenderLite: (index: number) => {
          const isActive = categories[index]?.active
          const color = isActive ? 'success' : 'danger'
          const text = isActive ? 'Ativo' : 'Inativo'
          return (
            <span className={`badge rounded-pill bg-${color}-subtle border-${color}-subtle text-${color}-emphasis`}>
              {text}
            </span>
          )
        },
      },
    },
    {
      name: '',
      label: '',
      options: {
        filter: false,
        customBodyRenderLite: (index: number) => (
          <Link
            className="btn btn-sm btn-warning"
            to={`/events/categories/update/${categories[index]?.id}`}
            title="Editar"
          >
            <i className="bi bi-pencil" aria-hidden="true"></i>
          </Link>
        ),
      },
    },
  ]

  return (
    <div className="mb-4">
      <Link className="btn btn-success mb-3" to={`/events/categories/create/${eventTypeId}`}>
        <i className="bi bi-plus-circle">&nbsp;</i> Cadastrar Categoria
      </Link>
      <MUIDataTable title={''} data={categories} columns={columns} options={DataTableOptions as any} />
    </div>
  )
}
